/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLaptop: {
  name: 'laptop';
  data: string;
} = {
  name: 'laptop',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm0 2h14v10H5V5ZM3 19a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H3Z" fill="currentColor"/></svg>`,
};
